import gql from "graphql-tag";


export const LIST_US_TAX_SETTINGS = gql`
  query usTaxSettings {
    usTaxSettings {
      stateCode
      name
      deductShippingCost
    }
  }
`;

export const ON_US_TAX_SETTINGS_UPDATED = gql`
  subscription onUsTaxSettingsUpdated {
    updatedUsTaxSettings {
      stateCode
    }
  }
`;

export const GET_US_TAX_SETTING = gql`
  query usTaxSetting($stateCode:String!) {
    usTaxSetting(stateCode: $stateCode) {
      stateCode
      name
      deductShippingCost
    }
  }
`;

export const GET_SHOP_SURCHARGES = gql`
  query shopSurcharges($shopId: ID!) {
    shopSurcharges(shopId: $shopId) {
      shopId
      countryCode
      countryName
      stateCode
      stateName
      productSku
      surcharge {
        currency
        value
      }
    }
  }
`;

export const ON_SHOP_SURCHARGE_UPDATED = gql`
  subscription updatedSurcharge($shopId: ID!) {
    updatedSurcharge(shopId: $shopId) {
      shopId
    }
  }
`;


export const GET_PRODUCT_SURCHARGE_FOR_LOCATION = gql`
  query productSurchargeForLocation($data: ProductSurchargeForLocationInput!) {
    productSurchargeForLocation(input: $data) {
      shopId
      countryCode
      countryName
      stateCode
      stateName
      productSku
      surcharge {
        currency
        value
      }
    }
  }
`

export const GET_ADD_PRODUCT_SURCHARGE = gql`
  query shopProductSurcharge($shopId: ID!) {
    shop(shopId: $shopId) {
      shopId
      title
      currencies
    }
    shopLocations(shopId: $shopId) {
      kind,
      code,
      name
    }
  }
`;


export const LIST_SHOPS = gql`
  query shops {
    shops {
      shopId
      title
      configured
      currencies
    }
  }
`;

export const LIST_SHOP_COUNTRIES = gql`
  query shopCountries($shopId: ID!) {
    shopCountries(shopId:$shopId) {
      shopId
      kind
      code
      name
      availability
    }
  }
`;

export const LOCATION_IN_SHOP = gql`
  query locationInShop($shopId:ID!, $kind:String!, $code:String!) {
    locationInShop(shopId: $shopId, kind: $kind, code: $code) {
      shopId
      kind
      code
      name
      availability
    }
  }
`;

export const ON_LOCATION_AVAILABILITY_UPDATED = gql`
  subscription updatedAvailabilityInShop($shopId: ID!) {
    updatedAvailabilityInShop(shopId: $shopId) {
      shopId
    }
  }
`;



export const LIST_SHOP_LOCATIONS = gql`
  query shopLocations($shopId: ID!) {
    shopLocations(shopId:$shopId) {
      shopId
      kind
      code
      name
      availability
    }
  }
`;


export const ON_CART_UPDATED = gql`
  subscription onCartUpdated($accountId: ID!) {
    updatedCart(accountId: $accountId) {
      account_id
    }
  }
`;


export const ON_SUBSCRIPTION_UPDATED = gql`
  subscription onSubscriptionUpdated($subscriptionId: ID!) {
    updatedSubscription(subscriptionId: $subscriptionId) {
      subscriptionId
    }
  }
`;

export const ON_ACCOUNT_SUBSCRIPTIONS_UPDATED = gql`
  subscription onAccountSubscriptionsUpdated($accountId: ID!) {
    updatedAccountSubscriptions(accountId: $accountId) {
      accountId
    }
  }
`;


export const GET_BILLING_ACCOUNT = gql`
  query getBillingAccount($accountId: ID!) {
    billingAccount(accountId: $accountId) {
      accountId
      countryCode
      currency
      shopId
      stateProvince
      type
      status
    }
  }
`;

export const LIST_SHOP_PRODUCTS = gql`
  query shopProducts($shopId: ID!) {
    shopProducts(shopId: $shopId) {
      shopId
      productSku
      productTitle
    }
  }
`;

export const LIST_SHOP_PRODUCTS_FOR_ACCOUNT = gql`
  query shopProductsForAccount($accountId: ID!) {
    shopProductsForAccount(accountId: $accountId) {
      shopId
      productSku
      productTitle
      pricing {
        currency
        value
      }
    }
  }
`;

export const LIST_ORDERS_FOR_ACCOUNT = gql`
  query ordersForAccount($filter:SalesOrderFilterInput, $pagination:PaginationInput) {
    salesOrders(filter: $filter, pagination: $pagination) {
      entries {
        orderId
        accountId
        shopId
        shippingOrderId
        currency
        total
        invoiceAvailable
        invoiceNr
        billingStatus
        billingAddress {
          name
        }
        source
        subscription
        gift
        promoCodeApplied
        paidAt
        createdAt
      }
      metadata {
        before
        after
        limit      
      }
    }
  }
`;

export const LIST_ORDERS = gql`
  query salesOrders($filter:SalesOrderFilterInput, $pagination:PaginationInput, $sortOrders:[SortingInput]) {
    salesOrders(filter: $filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        orderId
        accountId
        shopId
        shippingOrderId
        currency
        total
        discount
        invoiceAvailable
        invoiceNr
        billingStatus
        billingAddress {
          name
        }
        shippingAddress {
          name
        }
        source
        subscription
        gift
        promoCodeApplied
        paidAt
        createdAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const GET_ORDER = gql`
  query salesOrder($orderId:ID!) {
    salesOrder(orderId: $orderId) {
      orderId
      accountId
      shopId
      shippingOrderId
      subscriptionId
      subtotalProducts
      subtotalBeforeTaxes
      subtotalTaxes
      inCheckout
      currency
      total
      billingStatus
      source
      subscription
      status
      gift
      promoCodeApplied
      promoCode
      discount
      paidAt
      createdAt
      shipping {
        deliveryAddress {
          type        
          name
          attName
          phoneNr
          email
          addressAddressLine1
          addressAddressLine2
          addressCity
          addressPostcode
          addressStateProvince
          addressCountryCode
          addressCountryName
        }
      }
    }
  }
`;

export const LIST_META_ORDERS = gql`
  query salesMetaOrders($filter:SalesOrderFilterInput, $pagination:PaginationInput, $sortOrders:[SortingInput]) {
    salesMetaOrders(filter: $filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        metaOrderId
        shopId
        name
        state
        source
        isTestOrder
        createdAt
        lastUpdatedAt
        shippingOrderIds
        messages
        trackingInfo {
          metaItemId
          packageId
          productSku
          courierId
          trackingNumber
        }
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const GET_META_ORDER = gql`
  query salesMetaOrder($metaOrderId:String!) {
    salesMetaOrder(metaOrderId: $metaOrderId) {
      metaOrderId
      shopId
      name
      state
      source
      isTestOrder
      createdAt
      lastUpdatedAt
      shippingOrderIds
      messages
      trackingInfo {
        metaItemId
        packageId
        productSku
        courierId
        trackingNumber
      }
    }
  }
`;

export const GET_META_ORDER_HISTORY = gql`
  query salesMetaOrderHistory($metaOrderId:String!) {
    salesMetaOrderHistory(metaOrderId: $metaOrderId) {
      metaOrderId
      shopId
      name
      state
      message
      source
      shippingOrderId
      metaItemId
      productSku
      courierId
      trackingNumber
      isTestOrder
      createdAt
    }
  }
`;


export const GET_ORDER_WITH_PRODUCTS = gql`
  query salesOrder($orderId:ID!) {
    salesOrder(orderId: $orderId) {
      orderId
      accountId
      shopId
      shippingOrderId
      subtotalBeforeTaxes
      subtotalTaxes
      inCheckout
      currency
      total
      invoiceNr
      invoiceAvailable
      billingStatus
      subscription
      subscriptionName
      subscriptionFrequencyWeeks
      status
      reason
      gift
      paidAt
      createdAt
      products {
        productSku
        productTitle
        unitPrice
        subscription
        taxIncluded
        taxPercentage
        includedSurcharge
        currency
        quantity
      }
      shipping {
        deliveryAddress {
          type        
          name
          attName
          phoneNr
          email
          addressAddressLine1
          addressAddressLine2
          addressCity
          addressPostcode
          addressStateProvince
          addressCountryCode
          addressCountryName          
        }
      }
    }
  }
`;

export const LIST_CART_FOR_ACCOUNT = gql`
  query cartForAccount($accountId: ID!) {
    cart(accountId: $accountId) {
      nrItems
      subtotal
      currency
      accountId
      subscription
      subscriptionName
      subscriptionFrequencyWeeks
      items {
        productSku
        productTitle
        quantity
        unitPrice
        subscription
        subtotal
        currency
      }
    }
  }
`;

export const GET_PRODUCT_IN_CART = gql`
  query cartItem($accountId: ID!, $productSku: ID!, $subscription:Boolean ) {
    cartItem(accountId: $accountId, productSku: $productSku, subscription: $subscription) {
      accountId,
      productSku,
      productTitle,
      quantity,
      unitPrice,
      subscription,
      subtotal,
      currency      
    }
  }
`;

export const GET_SUBSCRIPTION_PRODUCT_IN_CART = gql`
  query cartSubscriptionItem($accountId: ID!, $productSku: ID!, $subscription:Boolean ) {
    cart(accountId: $accountId) {
      subscription
      subscriptionFrequencyWeeks      
    }
    cartItem(accountId: $accountId, productSku: $productSku, subscription: $subscription) {
      accountId,
      productSku,
      productTitle,
      quantity,
      unitPrice,
      subscription,
      subtotal,
      currency      
    }
    subscriptionFrequencyOptions {
      title
      value
    }
  }
`;


export const ON_CHECKOUT_INFO_UPDATED = gql`
  subscription onCheckoutInfoUpdated($orderId: ID!) {
    updatedOrderInfo(orderId: $orderId) {
      orderId
    }
  }
`;

export const ON_ORDER_UPDATED = gql`
  subscription onOrderUpdated($orderId: ID!) {
    updatedOrderInfo(orderId: $orderId) {
      orderId
    }
  }
`


export const ON_UPDATED_BILLING = gql`
  subscription updatedBilling($accountId: ID!) {
    updatedBilling(accountId: $accountId) {
      accountId
    }
  }
`;


export const CHECKOUT_INFO = gql`
  query checkoutInfo($orderId: ID!, $accountId: ID!) {
    checkoutInfo(orderId: $orderId) {
      orderId
      accountId
      shopId
      currency
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
        addressCountryName
      }
      invoiceNr
      billingStatus
      billingError
      billingAttempt
      billingDetailsStatus
      billingAddress {
        name
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode        
      }
      billingTaxId
      billingValidTaxId
      billingTaxExempt
      billingTaxExemptionDescription
      shippingAddressStatus
      subtotalProducts
      subtotalBeforeTaxes
      subtotalTaxes
      subscriptionFrequencyWeeks
      total
      discount
      promoCode
      promoCodeApplied
      canPay
      canChangeAddress
      isPreparing
      expired
      status
      gift
      giftMessage
      subscription
      subscriptionName
      products {
        productSku,
        productTitle,
        quantity,
        subscription,
        unitPrice,
        total,
        includesSurcharge,
        currency
      }
    }
    shippingAddresses(accountId: $accountId) {
      addressId 
      address {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
    billingDefaultPaymentMethod(accountId:$accountId) {
      paymentMethodId
      type
      cardBrand
      cardExpYear
      cardExpMonth
      cardLast4
      default
      addedAt
    }
    billingAccount(accountId:$accountId) {
      paymentMethod
      paymentTermsDays
      taxExempt
      taxExemptionDescription
    }    
    accountHolder(accountId:$accountId) {
      name
      email
    }
  }
`;
